import { useBrainStore } from '@/state/brainStore';
import { eventBus } from '@/events/eventBus';
import { addLeaveBlock, buildDayOffBlock, type DayOffInput } from '@/domain/artistAdmin';

/**
 * Create a dated day-off (RDO / comp / leave) on an artist's record. Single
 * write path shared by the calendar and the profile so both stay in sync.
 * Returns the created block id, or null if the artist is unknown.
 */
export function scheduleDayOff(artistId: string, input: DayOffInput): string | null {
  const brain = useBrainStore.getState();
  const artist = brain.artists[artistId];
  if (!artist) return null;
  const id = crypto.randomUUID();
  const block = buildDayOffBlock(input, id);
  brain.upsertArtist({ ...artist, availability: addLeaveBlock(artist.availability, block) });
  eventBus.publish('artist:day-off-scheduled', { artistId, kind: input.kind, date: input.date });
  return id;
}
